import { UiStructure } from "./Form_For_Inventory";

const School_Safety_Booklet = () => (
  <UiStructure
    title={"School Safety Booklet(MHA)"}
    label={"School Safety Booklet(MHA)"}
    fileStoreId={"0aca4c56-a669-47f4-80fd-956715f9c17b"}
  />
);

export default School_Safety_Booklet;
